import { Util } from '..';
import { PropertyType, FilterOperator } from '../../enums';
import { IOption } from '../../interfaces';
import { FilterOptions, FilterColumnOptions } from '../../interfaces/options';
import { KoExtensions } from '../../extensions/ko/observable';

export class FilterTableItem {
	public key: string;
	private label: string;
	private type: PropertyType;
	public operator: KnockoutObservable<FilterOperator>;
	private operatorData: IOption<FilterOperator>[];
	public value: KnockoutObservable<string>;
	constructor(filterColumn: FilterColumnOptions) {
		this.key = filterColumn.id;
		this.operator = ko.observable<FilterOperator>(filterColumn.operator || FilterOperator.LIKE);
		this.operatorData = Util.enumToOptions<FilterOperator>(FilterOperator);
		this.type = filterColumn.type;
		this.operator.subscribe(newValue => {
			//TODO change value input template based on FilterOperator e.g. Date or Boolean
		});
		this.value = KoExtensions.observable<string>(filterColumn.value);
		this.label = filterColumn.label;
	}
	public toFilterSetting(): FilterOptions {
		//TODO multiple params
		let operator: FilterOperator = this.operator();
		let value: any;
		switch (operator) {
			case FilterOperator.ISNOTIN:
				value = this.value()
					.split(',')
					.map(item => Util.convert(item, this.type));
				break;
			default:
				value = Util.convert(this.value(), this.type);
				break;
		}

		return <FilterOptions>{
			key: this.key,
			operator: this.operator(),
			params: [value],
			type: this.type
		};
	}
}
